module.exports = __webpack_public_path__ + "static/media/nellie-hit.0f0a8cd9.png";


//////////////////
// WEBPACK FOOTER
// ./public/assets/nellie-hit.png
// module id = 39
// module chunks = 0